import Lookup from 'src/componentes/select2';

const StatusDocumentoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/StatusDocumentoLookup"
    clearable
    {...rest}
  />
);

export default StatusDocumentoLookup;
